import client from './client'
import modules from './modules'
import { isArray, map, rejection } from '../views/utils'

/*
* Global data collector.
*/
function wrapInData(res) {
  if (typeof res === 'undefined') return rejection('Undefined response')

  if (isArray(res)) return Promise.resolve(res)

  // is error?
  if (res.code && res.message) return rejection(res)

  return Promise.resolve(res)
  // return Promise.resolve(res.id ? res : res.data)
}

/*
* Global error handler.
*/
function handleError(err) {
  if (err && err.name === 'NotAuthenticated') {
    err.message = 'Your access token has expired.'
    err.button = {
      text: 'Login',
      route: 'Login',
    }

    // clear jwt
    // delete window.localStorage['feathers-jwt']

    return Promise.reject(err)
  }

  return Promise.reject(err)
}

export const services = map(modules, (module) => {
  if (!module.serviceName) return undefined

  const service = client.getService(module.serviceName)
  const append = {
    create: data => service.create(data),
    get: id => service.get(id),
    find: query => service.find({ query }),
    delete: (id, params) => service.remove(id, params),
    update: (id, data, params) => service.update(id, data, params),
    patch: (id, data, params) => service.patch(id, data, params),
  }

  // error handling for all
  // return map(append, fn => (a, b) => fn(a, b).catch(handleError))
  return map(append, fn => (a, b, c) => fn(a, b, c).then(wrapInData).catch(handleError))
})

export { client }



// WEBPACK FOOTER //
// ./src/store/services.js